import type { ExternalStorageProvider } from '@/constants/constants-external-storage'

type ExternalStorageLinkedItem = {
  external_storage?: {
    provider: ExternalStorageProvider
    tombstoned: boolean
  } | null
}

export function isLocalStorageItem(item: ExternalStorageLinkedItem): boolean {
  return !item.external_storage
}

export function isVisibleExternalStorageItem(item: ExternalStorageLinkedItem, provider: ExternalStorageProvider | null | undefined): boolean {
  return !!provider && item.external_storage?.provider === provider && item.external_storage.tombstoned === false
}

export function filterLocalStorageItems<T extends ExternalStorageLinkedItem>(items: T[]): T[] {
  return items.filter(isLocalStorageItem)
}

export function filterVisibleExternalStorageItems<T extends ExternalStorageLinkedItem>(items: T[], provider: ExternalStorageProvider | null | undefined): T[] {
  return items.filter((item) => isVisibleExternalStorageItem(item, provider))
}
